/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { GetNameValueListResponse } from '../model/getNameValueListResponse';
import { GetNameValueResponse } from '../model/getNameValueResponse';
import { GetNameValuesResponse } from '../model/getNameValuesResponse';
import { ListEntry } from '../model/listEntry';
import { Response } from '../model/response';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { NameValueServiceInterface }                            from './nameValue.serviceInterface';


@Injectable()
export class NameValueService implements NameValueServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param name 
     * @param organization 
     * @param departmentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDepartmentNameValue1(name: string, organization?: string, departmentId?: number, observe?: 'body', reportProgress?: boolean): Observable<GetNameValueResponse>;
    public getDepartmentNameValue1(name: string, organization?: string, departmentId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetNameValueResponse>>;
    public getDepartmentNameValue1(name: string, organization?: string, departmentId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetNameValueResponse>>;
    public getDepartmentNameValue1(name: string, organization?: string, departmentId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling getDepartmentNameValue1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (departmentId !== undefined && departmentId !== null) {
            headers = headers.set('departmentId', String(departmentId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetNameValueResponse>(`${this.basePath}/namevalues/department/${encodeURIComponent(String(name))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param organization 
     * @param departmentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getDepartmentNameValueList1(name: string, organization?: string, departmentId?: number, observe?: 'body', reportProgress?: boolean): Observable<GetNameValueListResponse>;
    public getDepartmentNameValueList1(name: string, organization?: string, departmentId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetNameValueListResponse>>;
    public getDepartmentNameValueList1(name: string, organization?: string, departmentId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetNameValueListResponse>>;
    public getDepartmentNameValueList1(name: string, organization?: string, departmentId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling getDepartmentNameValueList1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (departmentId !== undefined && departmentId !== null) {
            headers = headers.set('departmentId', String(departmentId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetNameValueListResponse>(`${this.basePath}/namevalues/departmentlist/${encodeURIComponent(String(name))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEndUserNameValue1(name: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetNameValueResponse>;
    public getEndUserNameValue1(name: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetNameValueResponse>>;
    public getEndUserNameValue1(name: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetNameValueResponse>>;
    public getEndUserNameValue1(name: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling getEndUserNameValue1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetNameValueResponse>(`${this.basePath}/namevalues/enduser/${encodeURIComponent(String(name))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEndUserNameValueList1(name: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetNameValueListResponse>;
    public getEndUserNameValueList1(name: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetNameValueListResponse>>;
    public getEndUserNameValueList1(name: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetNameValueListResponse>>;
    public getEndUserNameValueList1(name: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling getEndUserNameValueList1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetNameValueListResponse>(`${this.basePath}/namevalues/enduserlist/${encodeURIComponent(String(name))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param names 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEndUserNameValues1(organization?: string, login?: string, names?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<GetNameValuesResponse>;
    public getEndUserNameValues1(organization?: string, login?: string, names?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetNameValuesResponse>>;
    public getEndUserNameValues1(organization?: string, login?: string, names?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetNameValuesResponse>>;
    public getEndUserNameValues1(organization?: string, login?: string, names?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (names) {
            names.forEach((element) => {
                queryParameters = queryParameters.append('names', <any>element);
            })
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetNameValuesResponse>(`${this.basePath}/namevalues/enduser/values`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param value 
     * @param organization 
     * @param departmentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setDepartmentNameValue1(name: string, value: string, organization?: string, departmentId?: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setDepartmentNameValue1(name: string, value: string, organization?: string, departmentId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setDepartmentNameValue1(name: string, value: string, organization?: string, departmentId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setDepartmentNameValue1(name: string, value: string, organization?: string, departmentId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling setDepartmentNameValue1.');
        }

        if (value === null || value === undefined) {
            throw new Error('Required parameter value was null or undefined when calling setDepartmentNameValue1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (departmentId !== undefined && departmentId !== null) {
            headers = headers.set('departmentId', String(departmentId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/namevalues/department/${encodeURIComponent(String(name))}/${encodeURIComponent(String(value))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param organization 
     * @param departmentId 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setDepartmentNameValueList1(name: string, organization?: string, departmentId?: number, body?: Array<ListEntry>, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setDepartmentNameValueList1(name: string, organization?: string, departmentId?: number, body?: Array<ListEntry>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setDepartmentNameValueList1(name: string, organization?: string, departmentId?: number, body?: Array<ListEntry>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setDepartmentNameValueList1(name: string, organization?: string, departmentId?: number, body?: Array<ListEntry>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling setDepartmentNameValueList1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (departmentId !== undefined && departmentId !== null) {
            headers = headers.set('departmentId', String(departmentId));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/namevalues/departmentlist/${encodeURIComponent(String(name))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param value 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setEndUserNameValue1(name: string, value: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setEndUserNameValue1(name: string, value: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setEndUserNameValue1(name: string, value: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setEndUserNameValue1(name: string, value: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling setEndUserNameValue1.');
        }

        if (value === null || value === undefined) {
            throw new Error('Required parameter value was null or undefined when calling setEndUserNameValue1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/namevalues/enduser/${encodeURIComponent(String(name))}/${encodeURIComponent(String(value))}`,
            null,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param name 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setEndUserNameValueList1(name: string, organization?: string, login?: string, body?: Array<ListEntry>, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setEndUserNameValueList1(name: string, organization?: string, login?: string, body?: Array<ListEntry>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setEndUserNameValueList1(name: string, organization?: string, login?: string, body?: Array<ListEntry>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setEndUserNameValueList1(name: string, organization?: string, login?: string, body?: Array<ListEntry>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (name === null || name === undefined) {
            throw new Error('Required parameter name was null or undefined when calling setEndUserNameValueList1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/namevalues/enduserlist/${encodeURIComponent(String(name))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setEndUserNameValues1(organization?: string, login?: string, body?: any, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public setEndUserNameValues1(organization?: string, login?: string, body?: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public setEndUserNameValues1(organization?: string, login?: string, body?: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public setEndUserNameValues1(organization?: string, login?: string, body?: any, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/namevalues/enduser/values`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
